import { Component, OnInit } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { Observable } from 'rxjs';
import { Helpers } from "../../helpers";
import { TranslateConfigService } from "../../theme/home/translateConfig.service";
import { HttpClient } from "../../../ajax/http-client.service";
import { appService } from "../../../app/_services/app.service";
const LNG_KEY = "SELECTED_LANGUAGE";
declare var $: any;
declare var google: any;

@Component({
  selector: 'app-Waypointsmap',
  templateUrl: './Waypoints.component.html'
  // styleUrls: ['./Waypoints.component.scss']
})
export class WaypointsMapComponent implements OnInit {
  selectedLang: string;
  // OrderDestinationLocation: any = [{location: 'rajkot', stopover: true, Order: 0},
  //                                   {location: 'surat',stopover: true, Order: 0},
  //                                   {location: 'ahmdabad',stopover: true, Order: 0},
  //                                   {location: 'vadodara', stopover: true, Order: 0}];
  isAssign: any = false;
  LiveTrackingThrowWarehouseLatLongFlage: any = false;
  OrderDestinationLocation: any = [];
  OrderInfo: any = [{ origin: 'jamnagar', destination: 'jamnagar' }];
  OrderInfoLatLong: any = [{ origin: 'jamnagar', destination: 'jamnagar' }];
  OrderDestinationLocation1: any = [];
  http: HttpClient;
  MapRadious: any;
  TripRouteBaseOnDeliveryDateFlag: any = false;

  constructor(
    private service: TranslateConfigService,
    private translate: TranslateService,
    private _appService: appService,
    private toastr: ToastrService
  ) {
    let language = 'en';
    let value = localStorage.getItem(LNG_KEY);
    if (value === "" || value === null || value === undefined) {
      this.translate.setDefaultLang(language);
      this.selectedLang = language;
    } else {
      this.service.setLanguage('en');
      this.selectedLang = 'en';
    }
    let val = localStorage.getItem(LNG_KEY);
  }

  ngOnInit() {
    // this.initMap();
    this.TripRouteBaseOnDeliveryDateFlag = JSON.parse(localStorage.getItem("TripRouteBaseOnDeliveryDateFlag"));
    this.GetLiveTrackingThrowWarehouseLatLongSettingVal();
  }

  initMap() {
    const directionsService = new google.maps.DirectionsService();
    const directionsRenderer = new google.maps.DirectionsRenderer();
    const map = new google.maps.Map(document.getElementById("Waypointsmap"), {
      zoom: 6,
      center: { lat: 41.85, lng: -87.65 },
    });
    directionsRenderer.setMap(map);
    this.calculateAndDisplayRoute(directionsService, directionsRenderer, map);
  }
  calculateAndDisplayRoute(directionsService, directionsRenderer, map) {
    const waypts = [];
    // waypts.push(this.OrderDestinationLocation);
    //add kevin 06-Jan-2022
    // var OrderDestinationLocationwaypts = [];
    // this.OrderDestinationLocation.map(function (item) {
    //   var existItemDelivery = OrderDestinationLocationwaypts.find((x) => x.OrderAddress == item.OrderAddress);
    //   if (!existItemDelivery) {
    //     var objDeliveryLocation: any = {};
    //     objDeliveryLocation.location = item.OrderAddress,
    //       objDeliveryLocation.stopover = true,
    //       objDeliveryLocation.Order = 0,
    //       objDeliveryLocation.RouteOrder = 'A',
    //       objDeliveryLocation.OrderNo = item.OrderNo,
    //       objDeliveryLocation.PickUpContactPersonDetail = item.PickUpContactPersonDetail,
    //       objDeliveryLocation.DeliveryContactPersonDetail = item.DeliveryContactPersonDetail,
    //       objDeliveryLocation.OrderAddress = item.OrderAddress,
    //       objDeliveryLocation.weight = item.weight,
    //       objDeliveryLocation.Qty = item.Qty,
    //       objDeliveryLocation.cbm = item.CBM
    //     OrderDestinationLocationwaypts.push(objDeliveryLocation);
    //   }
    // });
    //end
    for (let i = 0; i < this.OrderDestinationLocation.length; i++) {
      waypts.push({
        location: this.OrderDestinationLocation[i].location,
        stopover: true,
      });
    }
    directionsService.route(
      {
        origin: this.LiveTrackingThrowWarehouseLatLongFlage == true ? this.OrderInfoLatLong[0].origin : this.OrderInfo[0].origin,
        destination: this.LiveTrackingThrowWarehouseLatLongFlage == true ? this.OrderInfoLatLong[0].destination : this.OrderInfo[0].destination,
        waypoints: waypts,
        optimizeWaypoints: this.TripRouteBaseOnDeliveryDateFlag == true ? false : true,
        travelMode: google.maps.TravelMode.DRIVING,
      },
      (response, status) => {
        if (status === "OK") {
          // for(let rt=0; rt<response.geocoded_waypoints.length; rt++){
          //   if(rt==0 || rt+1==response.geocoded_waypoints.length){
          //     response.geocoded_waypoints[rt].types=[];
          //     // response.geocoded_waypoints[rt].types[0]='storage';
          //   }
          // }
          // console.log('SecondRouteResponce',response);
          directionsRenderer.setDirections(response);
          directionsRenderer = new google.maps.DirectionsRenderer({
            suppressMarkers: true
          });
          const route = response.routes[0];
          let ViewPoints = [];
          ViewPoints = response.routes[0].waypoint_order;
          var DestinationLocationSetOrder: any = [];
          for (let i = 0; i < ViewPoints.length; i++) {
            this.OrderDestinationLocation[ViewPoints[i]].Order = i;
            this.OrderDestinationLocation[ViewPoints[i]].RouteOrder = String.fromCharCode((i + 2) + 64);
            console.log('DistanceInKM', Math.round(response.routes[0].legs[i].distance.value / 1000));
            if (i == 0) {
              console.log(this.OrderInfo);
              DestinationLocationSetOrder.push(...this.OrderInfo.map(o => {
                return {
                  location: o.origin,
                  stopover: true,
                  Order: 0,
                  // RouteOrder: 'A',
                  RouteOrder: '',
                  OrderNo: 'Pickup',
                  PickUpContactPersonDetail: '',
                  DeliveryContactPersonDetail: '',
                  OrderDateFormated: '',
                  OrderAddress: o.origin,
                  OrderLatLong: this.OrderInfoLatLong.length > 0 ? this.OrderInfoLatLong[0].origin : '',
                  weight: '',
                  Qty: '',
                  cbm: ''
                };
              }));
            }
            DestinationLocationSetOrder.push(this.OrderDestinationLocation[ViewPoints[i]]);
            if (ViewPoints.length == (i + 1)) {
              DestinationLocationSetOrder.push(...this.OrderInfo.map(o => {
                return {
                  location: o.destination,
                  stopover: true,
                  Order: 0,
                  // RouteOrder: String.fromCharCode((i+3) + 64),
                  RouteOrder: '',
                  OrderNo: 'Destination',
                  PickUpContactPersonDetail: '',
                  DeliveryContactPersonDetail: '',
                  OrderDateFormated: '',
                  OrderAddress: o.destination,
                  OrderLatLong: this.OrderInfoLatLong.length > 0 ? this.OrderInfoLatLong[0].destination : '',
                  weight: '',
                  Qty: '',
                  cbm: ''
                };
              }));
            }
          }
          this.OrderDestinationLocation = DestinationLocationSetOrder;
          for (let index = 0; index < this.OrderDestinationLocation.length; index++) {
            // if (this.OrderDestinationLocation[index].OrderNo != 'Pickup' && this.OrderDestinationLocation[index].OrderNo != 'Destination') {
            this.OrderDestinationLocation[index].RouteOrder = String.fromCharCode(index + 65);
            // }

          }

          var bounds = new google.maps.LatLngBounds();
          route.legs.forEach(function (leg) {
            bounds.extend(leg.start_location);
            bounds.extend(leg.end_location);
          });

          // Calculate the center of the route
          var center = bounds.getCenter();

          // Draw a circle with a radius of 50km around the origin
          var originCircle = new google.maps.Circle({
            strokeColor: '#FF0000',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#FF0000',
            fillOpacity: 0.35,
            map: map,
            center: route.legs[0].start_location,
            radius: this.MapRadious // km in meters
          });

          // Draw a circle with a radius of 50km around the destination
          var destinationCircle = new google.maps.Circle({
            strokeColor: '#00FF00',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#00FF00',
            fillOpacity: 0.35,
            map: map,
            center: route.legs[route.legs.length - 1].end_location,
            radius: this.MapRadious // km in meters
          });

          // Optionally, display the radius value on the map
          var originInfowindow = new google.maps.InfoWindow({
            content: "Origin Radius: 50km"
          });

          var destinationInfowindow = new google.maps.InfoWindow({
            content: "Destination Radius: 50km"
          });

          originInfowindow.open(map, originCircle);
          destinationInfowindow.open(map, destinationCircle);

        } else {
          window.alert("Directions request failed due to " + status);
        }
      }
    );
  }

  async removeOriginAndDestination() {
    var OrderInfo: any = [];
    var obj1: any = {};
    obj1.origin = this.LiveTrackingThrowWarehouseLatLongFlage == true ? this.OrderInfoLatLong[0].origin : this.OrderInfo[0].origin;
    obj1.destination = this.LiveTrackingThrowWarehouseLatLongFlage == true ? this.OrderInfoLatLong[0].destination : this.OrderInfo[0].destination;
    OrderInfo.push(obj1);

    const waypts_Main = [];
    const waypts = [];
    for (let i = 0; i < this.OrderDestinationLocation.length; i++) {
      waypts_Main.push({
        location: this.OrderDestinationLocation[i].location,
        RouteOrder: '',
        stopover: true,
      });
    }

    for (let i = 0; i < waypts_Main.length; i++) {
      waypts.push({
        location: waypts_Main[i].location,
        stopover: true,
      });
    }

    const directionsService = new google.maps.DirectionsService();
    await directionsService.route(
      {
        origin: OrderInfo[0].origin,
        destination: OrderInfo[0].destination,
        waypoints: waypts,
        optimizeWaypoints: true,
        travelMode: google.maps.TravelMode.DRIVING,
      },
      (response, status) => {
        console.log('responseMap', response);
        if (status === "OK") {
          let ViewPoints = [];
          ViewPoints = response.routes[0].waypoint_order;
          var mainNum = 65;
          var subNum = 63;
          for (let i = 0; i < ViewPoints.length; i++) {
            waypts_Main[ViewPoints[i]].Order = i;
            waypts_Main[ViewPoints[i]].RouteOrder = subNum == 63 ? String.fromCharCode(mainNum) : String.fromCharCode(mainNum) + String.fromCharCode(subNum);
            if (mainNum == 90 || subNum == 90) {
              mainNum = subNum == 63 ? 65 : mainNum + 1;
              subNum = 64;
            }
            subNum = subNum == 63 ? subNum : subNum + 1;
            mainNum = subNum == 63 ? mainNum + 1 : mainNum;
          }
          for (let i = 0; i < this.OrderDestinationLocation.length; i++) {
            for (let j = 0; j < waypts_Main.length; j++) {
              if (this.OrderDestinationLocation[i].location == waypts_Main[j].location) {
                this.OrderDestinationLocation[i].RouteOrder = waypts_Main[j].RouteOrder;
              }
            }
          }
          console.log('this.OrderDestinationLocation', this.OrderDestinationLocation);
          // this.OrderInfoLatLong[0].origin = this.OrderDestinationLocation[0].location;
          // this.OrderInfo[0].origin = this.OrderDestinationLocation[0].location;
          this.OrderInfoLatLong[0].destination = this.OrderDestinationLocation[this.OrderDestinationLocation.length - 1].location;
          this.OrderInfo[0].destination = this.OrderDestinationLocation[this.OrderDestinationLocation.length - 1].location;
          this.initMap();

        } else {
          window.alert("Directions request failed due to " + status);
          this.initMap();
        }
      }
    );

  }

  PrintRouteOpt() {
    Helpers.setLoading(true);
    setTimeout(() => {
      var divElements = document.getElementById("RouteOpt");
      var $iframe = $("<iframe id='frame'>").appendTo("body");
      var printDiv = divElements.innerHTML;
      var win = $iframe[0].contentWindow || $iframe[0];
      $(win.document).ready(function () {
        setTimeout(() => {
          win.window.print();
          setTimeout(() => {
            $iframe.remove();
          }, 500);
        });
      });
      $iframe.contents().find("body").html(printDiv);
      Helpers.setLoading(false);
    }, 1000);
  }

  async calculateRouteOptimization(OrderInfoData, DestinationLocation): Promise<Observable<any>> {
    try {
      if (DestinationLocation.length > 1) {
        const directionsService = new google.maps.DirectionsService();
        const waypts = [];
        for (let i = 0; i < DestinationLocation.length; i++) {
          waypts.push({
            location: DestinationLocation[i].location,
            stopover: true,
          });
        }
        await directionsService.route(
          {
            origin: OrderInfoData[0].origin,
            destination: OrderInfoData[0].destination,
            waypoints: waypts,
            optimizeWaypoints: true,
            travelMode: google.maps.TravelMode.DRIVING,
          },
          (response, status) => {
            if (status === "OK") {
              let ViewPoints = [];
              ViewPoints = response.routes[0].waypoint_order;
              var mainNum = 65;
              var subNum = 63;
              for (let i = 0; i < ViewPoints.length; i++) {
                DestinationLocation[ViewPoints[i]].Order = i;
                DestinationLocation[ViewPoints[i]].RouteOrder = subNum == 63 ? String.fromCharCode(mainNum) : String.fromCharCode(mainNum) + String.fromCharCode(subNum);
                if (mainNum == 90 || subNum == 90) {
                  mainNum = subNum == 63 ? 65 : mainNum + 1;
                  subNum = 64;
                }
                subNum = subNum == 63 ? subNum : subNum + 1;
                mainNum = subNum == 63 ? mainNum + 1 : mainNum;
              }
              // this.OrderDestinationLocation1=(DestinationLocation);
              // return this.OrderDestinationLocation1;

            } else {
              // window.alert("Directions request failed due to " + status);
            }
          }
        );
      }
    } catch (error) {
      return DestinationLocation;
    }
    return DestinationLocation;
  }

  GetLiveTrackingThrowWarehouseLatLongSettingVal() {
    this._appService.GetById("Common", "GetSystemSettingByName", "LiveTrackingThrowWarehouseLatLong").subscribe((response) => {
      if (response == "1") {
        this.LiveTrackingThrowWarehouseLatLongFlage = true;
      } else {
        this.LiveTrackingThrowWarehouseLatLongFlage = false;
      }
    },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      });
  }

  //added by vithujan 01-04-2024 - Siddarth
  geocodeAddress(address, from) {
    var geocoder = new google.maps.Geocoder();

    geocoder.geocode({ 'address': address }, function (results, status) {
      if (status === 'OK') {
        var location = results[0].geometry.location;
        if (from == 'Pickup') {

        }
        if (from == 'Delivery') {

        }
      } else {
        alert('Geocode was not successful for the following reason: ' + status);
      }
    });
  }

}
